// import { DirectiveFunction } from 'vue'

// const preventScroll: DirectiveFunction = (el, binding) => {
//   if (binding.value !== false) {
//     el.addEventListener('touchmove', (e) => {
//       e.preventDefault()
//     })
//   }
// }
import { DirectiveOptions } from 'vue'

const preventScroll: DirectiveOptions = {
  bind(el, binding) {
    const elAny = el as any
    elAny.handler = (e: MouseEvent) => {
      e.preventDefault()
    }
    if (binding.value) {
      el.addEventListener('touchmove', elAny.handler)
    } else {
      el.removeEventListener('touchmove', elAny.handler)
    }
  },
  unbind(el) {
    const elAny = el as any
    if (!elAny.handler) return

    el.removeEventListener('click', elAny.handler)
    elAny.handler = null
  }
}

export default preventScroll
